import React from "react";
import "./Header.css";
function Header() {
  return (
    <header>
      <h1>HelloWorld</h1>
    </header>
  );
}

export default Header;
